import React, { useEffect } from "react";
import axios from "axios";
import BASE_URL from "./index";
import Cookies from "js-cookie";
import { calendarDay } from "../utils/calendarDay";
const currentUser =
  Cookies.get("currentUser") && JSON.parse(Cookies.get("currentUser"));

export const getCinematography = async (
  startDate,
  endDate,
) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/get-Cinematography`,
      {
        headers: { "Content-Type": "application/json" },
        params: {
          startDate: calendarDay(startDate),
          endDate: calendarDay(endDate)
        }
      }
    );

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAlbums = async (
  startDate,
  endDate
) => {
  try {
    const res = await axios.get(
      BASE_URL +
      `/get-Albums`,
      {
        Headers: { "Content-Type": "application/json" },
        params: {
          startDate: calendarDay(startDate),
          endDate: calendarDay(endDate)
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getPhotos = async (
  startDate,
  endDate,
) => {
  try {
    const res = await axios.get(
      BASE_URL +
      `/get-Photos`,
      {
        Headers: { "Content-Type": "application/json" },
        params: {
          startDate: calendarDay(startDate),
          endDate: calendarDay(endDate)
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};



export const getPreWeds = async (
  startDate,
  endDate
) => {
  try {
    const res = await axios.get(
      BASE_URL +
      `/get-Pre-Weds`,
      {
        Headers: { "Content-Type": "application/json" },
        params: {
          startDate: calendarDay(startDate),
          endDate: calendarDay(endDate)
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllTheDeadline = async (page) => {
  try {
    const res = await axios.get(
      BASE_URL + `/deliverableOptions/getAllDeliverableDays`,
      {
        Headers: { "Content-Type": "application/json" },
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

// Resolves true when saved. A refusal - such as marking Delivered with no
// delivery link, or someone else having saved the row first - is shown to the user with the server's reason, and resolves
// false so the screen can reload what is actually stored.
export const updateDeliverable = async (deliverable) => {
  try {
    const res = await axios.post(BASE_URL + "/update-Deliverable", {
      Headers: {
        "Content-Type": "application/json",
      },
      deliverable,
    });
    // The server versions each save so conflicting edits are caught; keep the
    // row's version current so this screen's next save of it is accepted.
    if (Number.isInteger(res.data?.version)) deliverable.__v = res.data.version;
    // ...and show a final delivery date the server filled in on delivery.
    if (res.data?.finalDeliveryDate && !deliverable.finalDeliveryDate) {
      deliverable.finalDeliveryDate = res.data.finalDeliveryDate;
    }
    window.notify("Deliverable updated successfully!", "success");
    return true;
  } catch (error) {
    console.log(error);
    window.notify(error.response?.data?.message || "The deliverable could not be saved.", "error");
    return false;
  }
};


export const getEditorsData = async (
  page,
  editorId,
) => {
  try {
    const res = await axios.get(
      BASE_URL +
      `/get-editorsdata`,
      {
        Headers: { "Content-Type": "application/json" },
        params: {
          page,
          editorId
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getEditorsList = async () => {
  try {
    const res = await axios.get(
      BASE_URL +
      `/all-editors`,
      {
        Headers: { "Content-Type": "application/json" }
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};